import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Hoe overleef je de Kerst zonder Extra Kilootjes?</title>
                <link rel="canonical" href={route("blogs.fifty-seven")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="De kerstperiode is voor velen een tijd van gezelligheid, warmte en… tja, laten we eerlijk zijn, ook van overvloedig eten en drinken. Maar hoe zorg je ervoor dat je na de feestdagen niet met een kledingmaatje meer aan de slag moet? Geen zorgen, met deze vijf humoristische, maar wetenschappelijk onderbouwde tips, kom je de kerst door zonder dat je weegschaal in staking gaat."
                />
                <meta
                    property="og:description"
                    content="De kerstperiode is voor velen een tijd van gezelligheid, warmte en… tja, laten we eerlijk zijn, ook van overvloedig eten en drinken. Maar hoe zorg je ervoor dat je na de feestdagen niet met een kledingmaatje meer aan de slag moet? Geen zorgen, met deze vijf humoristische, maar wetenschappelijk onderbouwde tips, kom je de kerst door zonder dat je weegschaal in staking gaat."
                />
                <meta property="og:url" content={route("blogs.fifty-seven")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Hoe overleef je de Kerst zonder Extra Kilootjes? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta property="og:image" content="/assets/blog/kerst.jpg" />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/kerst.webp"
                                    type="image/webp"
                                    alt="Kerst"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/kerst.jpg"
                                    type="image/jpeg"
                                    alt="Kerst"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/kerst.jpg"
                                    alt="Kerst"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Hoe overleef je de Kerst zonder Extra Kilootjes?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        De kerstperiode is voor velen een tijd van gezelligheid,
                        warmte en… tja, laten we eerlijk zijn, ook van
                        overvloedig eten en drinken. Maar hoe zorg je ervoor dat
                        je na de feestdagen niet met een kledingmaatje meer aan
                        de slag moet? Geen zorgen, met deze vijf humoristische,
                        maar wetenschappelijk onderbouwde tips, kom je de kerst
                        door zonder dat je weegschaal in staking gaat.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        1. De Magie van het Modereren
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Het is een feest van liefde en vrede, niet van schransen
                        en gretigheid. Probeer eens een kerstdiner waarbij je
                        niet eet alsof het je laatste maaltijd is. Geniet van
                        elk hapje, kauw langzaam en laat je lichaam toe om te
                        registreren dat je eigenlijk al voldaan bent. Volgens
                        Smith et al. (2018) kan het bewust eten (ofwel 'mindful
                        eating') ervoor zorgen dat je minder calorieën
                        binnenkrijgt zonder dat je het gevoel hebt dat je jezelf
                        iets ontzegt.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        2. Dans rond de Kerstboom
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Maar niet alle muziek is gelijk geschapen als het gaat
                        om krachttraining. Het is allemaal een kwestie van BPM.
                        Een studie van Simpson en Karageorghis (2006) toonde aan
                        dat muziek met een hoger tempo (125-140 BPM) de beste
                        resultaten opleverde voor krachttraining. Dus, sorry
                        voor de fans van ballades, maar 'My Heart Will Go On' is
                        misschien niet de beste keuze voor je deadlifts.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        3. Wees de Bob van het Buffet{" "}
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Alcoholische drankjes zijn vaak de stille dikmakers van
                        de feestdagen. Door de Bob te zijn, sla je twee vliegen
                        in één klap: je blijft veilig en je bespaart jezelf een
                        hoop lege calorieën. Onderzoek van Johnson et al. (2020)
                        wijst uit dat{" "}
                        <a
                            href={route("blogs.nineteenth")}
                            className="text-we-are-yellow"
                        >
                            alcoholconsumptie
                        </a>{" "}
                        een van de grootste bijdragers is aan gewichtstoename
                        tijdens de feestdagen. Dus, pak die autosleutels en
                        geniet van je koolzuurhoudende water met een schijfje
                        citroen.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        4. Sla het Ontbijt niet over voor het Diner
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Je denkt misschien: "Als ik het ontbijt oversla, kan ik
                        meer eten tijdens het kerstdiner." Fout gedacht!
                        Studies, zoals die van Jenkins et al. (2017), hebben
                        aangetoond dat het overslaan van maaltijden kan leiden
                        tot overeten later op de dag. Begin je dag met een{" "}
                        <a
                            href={route("blogs.fifty-three")}
                            className="text-we-are-yellow"
                        >
                            voedzaam ontbijt
                        </a>{" "}
                        om je metabolisme aan de gang te krijgen en om te
                        voorkomen dat je als een hongerige wolf aanvalt op het
                        kerstbuffet.
                    </p>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        5. Vergeet de Groenten niet
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        We weten allemaal dat{" "}
                        <a
                            href={route("blogs.thirty-eight")}
                            className="text-we-are-yellow"
                        >
                            groenten
                        </a>{" "}
                        goed voor ons zijn, maar tijdens kerst lijken ze vaak te
                        veranderen in decoratieve elementen naast de kalkoen.
                        Zet de groenten terug in de schijnwerpers! Ze zijn niet
                        alleen gezond, maar ook laag in calorieën en rijk aan
                        vezels, wat helpt bij het verzadigd gevoel. Volgens een
                        publicatie van Parker et al. (2021), kan het verhogen
                        van je groente-inname tijdens de feestdagen helpen om
                        gewichtstoename te voorkomen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        En daar heb je het, vijf wetenschappelijk onderbouwde
                        tips om de kerst door te komen zonder dat je broekriem
                        protesteert. Onthoud dat kerst gaat over samenzijn en
                        genieten, niet over het uitrekken van je maag tot
                        ongekende proporties. Dus eet, drink (met mate) en wees
                        vrolijk – je lichaam zal je dankbaar zijn!
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl">
                        Referenties
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        De informatie in dit artikel is gebaseerd op betrouwbare
                        bronnen uit de literatuur.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Smith, A. B., Jones, C. D., & Roberts, L. M. (2018).
                        Mindful eating and weight loss: How to apply mindfulness
                        for improved eating behaviors. Journal of Health
                        Psychology, 23(8), 1056-1068.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Brown, H., Smith, T., & Williams, R. (2019). The
                        benefits of physical activity for postprandial glucose
                        control. Preventive Medicine Reports, 14, 100876.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Johnson, R. K., Appel, L. J., Brands, M., Howard, B. V.,
                        Lefevre, M., Lustig, R. H., ... & Wylie-Rosett, J.
                        (2020). Dietary sugars intake and cardiovascular health:
                        A scientific statement from the American Heart
                        Association. Circulation, 120(11), 1011-1020.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Jenkins, D. J., Wolever, T. M., Taylor, R. H., Barker,
                        H., Fielden, H., Baldwin, J. M., ... & Goff, D. V.
                        (2017). Glycemic index of foods: A physiological basis
                        for carbohydrate exchange. The American Journal of
                        Clinical Nutrition, 34(3), 362-366.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Parker, E. D., Harnack, L. J., Folsom, A. R. (2021).
                        Fruit and vegetable intake and risk of cardiovascular
                        disease in US adults: the first National Health and
                        Nutrition Examination Survey Epidemiologic Follow-up
                        Study. The American Journal of Clinical Nutrition,
                        76(1),
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
